<template lang="pug">
.vprControlworksComponent( v-if="$route.name === 'VprControlworks'" )
  .navbar
    a.back( @click="onBackClick" )
      ui-svg-icon.backIcon(
        name="arrow-back"
        :size="16"
      )
      span Назад

  .subthemeContent(v-if="subtheme")
    .title {{ subtheme.title }}
    .taskWrapper(
      v-for="task in subtheme.tasks"
      :key="task.id"
    )
      .taskTitle( @click="onTaskClick(task.id)" )
        .label {{ task.title }}
        ui-svg-icon.highLevel(
          v-if="task.highLevel"
          name="task-star"
          :size="18"
          :originalColors="true"
        )

      ui-svg-icon.smile(
        v-if="task.progress?.statusSmileName"
        :name="task.progress.statusSmileName"
        :size=28
        :originalColors="true"
      )

router-view(v-else)
</template>

<script>
import { inject, computed } from 'vue'
import { useRouter } from 'vue-router'

export default {
  props: {
    subthemeId: {
      type: Number,
      required: true
    }
  },
  setup (props) {
    const controller = inject('controller')
    const router = useRouter()
    const userItem = computed(() => controller.childVpr.value?.userItem)
    const subtheme = computed(() => userItem.value?.vpr.findSubthemeById(props.subthemeId))

    const onBackClick = () => {
      router.push({ name: 'VprContents', params: { id: userItem.value.id } })
    }
    const onTaskClick = id => {
      router.push({ name: 'VprTask', params: { taskId: id } })
    }

    return {
      childVpr: controller.childVpr,
      subtheme,
      onBackClick,
      onTaskClick
    }
  }
}
</script>

<style lang="sass" scoped>
.vprControlworksComponent

  > .navbar
    margin-bottom: 7.5*$u
    > a
      width: fit-content
      display: flex
      align-items: center
      color: $cBlue
      cursor: pointer

      > span
        @include font('t16-medium')
        margin-left: 2.5*$u

      &:hover
        color: $cLightBlue
      &:active
        color: $cDarkBlue

  > .subthemeContent
    border-radius: $brL
    background-color: $cWhite
    overflow: hidden

    > .title
      @include font('h2')
      padding: 9*$u 7.5*$u 7.5*$u 7.5*$u
      @media (max-width: 948px)
        @include font('m-h2')
        padding: 5*$u

    > .taskWrapper
      display: flex
      align-items: center
      justify-content: space-between
      @include font('t18-regular')
      padding: 4*$u 7.5*$u
      @media (max-width: 948px)
        @include font('m-t18-regular')
        padding: 4*$u 5*$u

      &:nth-child(2n)
        background-color: $cElements

      > .taskTitle
        display: flex
        align-items: center

        &:hover
          color: $cBlue
          cursor: pointer
</style>
